export enum ActionTypes {
  //CUSOMIZER CONST
  TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU',
  WINDOW_WIDTH = 'WINDOW-WIDTH',
  SWITCH_LANGUAGE = 'SWITCH-LANGUAGE',

  //CONTACT MODULE CONST
  FETCH_START = 'fetch_start',
  FETCH_SUCCESS = 'fetch_success',
  FETCH_ERROR = 'fetch_error',
  SHOW_MESSAGE = 'SHOW_MESSAGE',
  HIDE_MESSAGE = 'HIDE_MESSAGE',
  ON_SHOW_LOADER = 'ON_SHOW_LOADER',
  ON_HIDE_LOADER = 'ON_HIDE_LOADER',

  //AUTH CONST
  SIGNUP_USER = 'SIGNUP_USER',
  SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS',
  SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER',
  SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS',
  SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER',
  SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS',
  SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER',
  SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS',
  SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER',
  SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success',
  SIGNIN_USER = '@@SIGNIN_USER',
  SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS',
  SIGNOUT_USER = 'SIGNOUT_USER',
  SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS',
  INIT_URL = 'INIT_URL',
  GET_User_Employee_Position = 'GET_User_Employee_Position',

  //STICKY
  GET_STICKY = 'GET_STICKY',
  NOTES_UPDATE = 'NOTES_UPDATE',
  FETCH_ALL_NOTES_SUCCESS = 'FETCH_ALL_NOTES_SUCCESS',
  UPDATE_ALL_NOTES_SUCCESS = 'UPDATE_ALL_NOTES_SUCCESS',

  //CONTACT
  GET_All_CONTACT_SUCCESS = 'GET_All_CONTACT_SUCCESS',
  ON_ADD_CONTACT_SUCCESS = 'ON_ADD_CONTACT_SUCCESS',
  UPDATE_CONTACT_SUCCESS = 'UPDATE_CONTACT_SUCCESS',
  DELETE_CONTACT_SUCCESS = 'DELETE_CONTACT_SUCCESS',
  //************
  GET_CONTACTS = 'GET_CONTACTS',
  FETCH_CONTACTS_SUCCESS = 'FETCH_CONTACTS_SUCCESS',

  // Base Config => company name
  GET_Company_Name = 'GET_Company_Name',
  FETCH_GET_Company_Name_SUCCESS = 'FETCH_GET_Company_Name_SUCCESS',

  // Home => recent news
  GET_RECENT_NEWS = 'GET_RECENT_NEWS',
  FETCH_RECENT_NEWS_SUCCESS = 'FETCH_RECENT_NEWS_SUCCESS',
  // Home => automation statistics
  GET_AUTOMATION_STATISTICS = 'GET_AUTOMATION_STATISTICS',
  FETCH_AUTOMATION_STATISTICS_SUCCESS = 'FETCH_AUTOMATION_STATISTICS_SUCCESS',
  // NEWS
  GET_NEWS = 'GET_NEWS',
  FETCH_NEWS_SUCCESS = 'FETCH_NEWS_SUCCESS',
  GET_NEWS_BY_ID = 'GET_NEWS_BY_ID',
  CLEAR_NEWS_ITEM = 'CLEAR_NEWS_ITEM',
  FETCH_NEWS_BY_ID_SUCCESS = 'FETCH_NEWS_BY_ID_SUCCESS',
  // DOWNLOAD IMAGE
  GET_DOWNLOAD_IMAGE = 'GET_DOWNLOAD_IMAGE',
  FETCH_DOWNLOAD_IMAGE_SUCCESS = 'FETCH_DOWNLOAD_IMAGE_SUCCESS',

  // DOWNLOAD FILE
  GET_DOWNLOAD_File = 'GET_DOWNLOAD_File',
  FETCH_DOWNLOAD_File_SUCCESS = 'FETCH_DOWNLOAD_File_SUCCESS',

  //INSTANCE
  GET_LIST_INSTANCE = 'GET_LIST_INSTANCE',
  CLEAR_LIST_INSTANCE = 'CLEAR_LIST_INSTANCE',
  FETCH_LIST_INSTANCE_SUCCESS = 'FETCH_GET_LIST_INSTANCE_SUCCESS',

  GET_AS_LIST_INSTANCE = 'GET_AS_LIST_INSTANCE',
  FETCH_AD_LIST_INSTANCE_SUCCESS = 'FETCH_GET_LIST_INSTANCE_SUCCESS',

  DELETE_REFER = 'DELETE_REFER',
  DELETE_REFER_SUCCESS = 'DELETE_REFER_SUCCESS',

  RESTORE_LETTER = 'RESTORE_LETTER',
  RESTORE_LETTER_SUCCESS = 'RESTORE_LETTER_SUCCESS',

  //USER  PROFILE
  GET_USER_PROFILE = 'GET_USER_PROFILE',
  FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS',

  //REMINDER
  GET_REMINDER = 'GET_REMINDER',
  FETCH_REMINDER_SUCCESS = 'FETCH_REMINDER_SUCCESS',
  CHANGE_REMINDER = 'CHANGE_REMINDER',
  GET_REMINDER_RECEIVERS = 'GET_REMINDER_RECEIVERS',
  FETCH_REMINDER_RECEIVERS_SUCCESS = 'FETCH_REMINDER_RECEIVERS_SUCCESS',
  CHANGE_REMINDER_STATE_ITEM_VALUE_WITH_TYPE = 'CHANGE_REMINDER_STATE_ITEM_VALUE_WITH_TYPE',
  ADD_REMINDER = 'ADD_REMINDER',

  //LETTER
  GET_LETTER_DETAIL = 'GET_LETTER_DETAIL',
  FETCH_LETTER_DETAIL_SUCCESS = 'FETCH_LETTER_DETAIL_SUCCESS',
  SAVE_LETTER = 'SAVE_LETTER',
  SAVE_LETTER_SUCCESS = 'SAVE_LETTER_SUCCESS',
  GET_LETTER_LOCATION = 'GET_LETTER_LOCATION',
  FETCH_LETTER_LOCATION_SUCCESS = 'FETCH_LETTER_LOCATION_SUCCESS',
  GET_LETTER_TEMPLATE = 'GET_LETTER_TEMPLATE',
  GET_LETTER_TEMPLATE_SUCCESS = 'GET_LETTER_TEMPLATE_SUCCESS',
  //NOTE
  GET_LETTER_NOTE = 'GET_LETTER_NOTE',
  FETCH_LETTER_NOTE_SUCCESS = 'FETCH_LETTER_NOTE_SUCCESS',
  ADD_LETTER_NOTE = 'ADD_LETTER_NOTE',
  ADD_LETTER_NOTE_SUCCESS = 'ADD_LETTER_NOTE_SUCCESS',

  //DRAFT
  GET_DRAFT_DETAIL = 'GET_DRAFT_DETAIL',
  FETCH_DRAFT_DETAIL_SUCCESS = 'FETCH_DRAFT_DETAIL_SUCCESS',
  GET_LETTER_REFERS = 'GET_LETTER_REFERS',
  FETCH_LETTER_REFERS_SUCCESS = 'FETCH_LETTER_REFERS_SUCCESS',
  GET_LETTER_REFER_TYPES = 'GET_LETTER_REFER_TYPES',
  FETCH_LETTER_REFER_TYPES_SUCCESS = 'FETCH_LETTER_REFER_TYPES_SUCCESS',
  GET_LETTER_REFER_SEND_TYPES = 'GET_LETTER_REFER_SEND_TYPES',
  FETCH_LETTER_REFER_SEND_TYPES_SUCCESS = 'FETCH_LETTER_REFER_SEND_TYPES_SUCCESS',
  ON_CLEAR_DRAFT_RECEIVERS = 'ON_CLEAR_DRAFT_RECEIVERS',
  ON_CLEAR_DRAFT = 'ON_CLEAR_DRAFT',
  // CHANGE_SENDER_CODE = "CHANGE_SENDER_CODE",
  //ATTACHMENT
  GET_Attachment = 'GET_Attachment',
  FETCH_Attachment_SUCCESS = 'FETCH_Attachment_SUCCESS',
  CHANGE_Attachment = 'CHANGE_Attachment',
  CHANGE_Attachment_SUCCESS = 'CHANGE_Attachment_SUCCESS',
  GET_Attachment_BY_ID = 'GET_Attachment_BY_ID',
  FETCH_Attachment_BY_ID_SUCCESS = 'FETCH_Attachment_BY_ID_SUCCESS',
  UPLOAD_ATTACHMENT = 'UPLOAD_ATTACHMENT',
  UPLOAD_ATTACHMENT_SUCCESS = 'UPLOAD_ATTACHMENT_SUCCESS',
  REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT',
  REMOVE_ATTACHMENT_SUCCESS = 'REMOVE_ATTACHMENT_SUCCESS',
  CLEAR_ATTACHMENT = 'CLEAR_ATTACHMENT',
  //LETTER BODY
  GET_LetterBody = 'GET_LetterBody',
  CLEAR_LetterBody = 'CLEAR_LetterBody',
  FETCH_LetterBody_SUCCESS = 'FETCH_LetterBody_SUCCESS',

  //CONVERT STATUS
  GET_CONVERTSTATUS = 'GET_CONVERTSTATUS',
  FETCH_CONVERTSTATUS_SUCCESS = 'FETCH_CONVERTSTATUS_SUCCESS',

  //LETTER BODY IMAGE
  //LETTER_REFER_TYPES_STATICS
  CLEAR_Letter_Refer_Inbox_Types_Statics = 'CLEAR_Letter_Refer_Inbox_Types_Statics',
  GET_Letter_Refer_Inbox_Types_Statics = 'GET_Letter_Refer_Inbox_Types_Statics',
  FETCH_Letter_Refer_Inbox_Types_Statics_SUCCESS = 'FETCH_Letter_Refer_Inbox_Types_Statics_SUCCESS',

  CLEAR_Letter_Refer_SendBox_Types_Statics = 'CLEAR_Letter_Refer_SendBox_Types_Statics',
  GET_Letter_Refer_SendBox_Types_Statics = 'GET_Letter_Refer_SendBox_Types_Statics',
  FETCH_Letter_Refer_Sendbox_Types_Statics_SUCCESS = 'FETCH_Letter_Refer_Sendbox_Types_Statics_SUCCESS',
  GET_DMS_TREE_MENU = 'GET_DMS_TREE_MENU',
  GET_DMS_TREE_MENU_SUCCESS = 'GET_DMS_TREE_MENU_SUCCESS',
  //EMPLOYEE_POSITION_FOLDERS
  CLEAR_INBOX_EMPLOYEE_POSITION_FOLDERS = 'CLEAR_INBOX_EMPLOYEE_POSITION_FOLDERS',
  GET_INBOX_EMPLOYEE_POSITION_FOLDERS = 'GET_INBOX_EMPLOYEE_POSITION_FOLDERS',
  FETCH_INBOX_EMPLOYEE_POSITION_fOLDERS_SUCCESS = 'FETCH_INBOX_EMPLOYEE_POSITION_fOLDERS_SUCCESS',
  GET_EMPLOYEE_POSITION_FAST_REFERS = 'GET_EMPLOYEE_POSITION_FAST_REFERS',
  FETCH_EMPLOYEE_POSITION_FAST_REFERS_SUCCESS = 'FETCH_EMPLOYEE_POSITION_FAST_REFERS_SUCCESS',
  GET_EMPLOYEE_POSITION_FAST_ARCHIVE = 'GET_EMPLOYEE_POSITION_FAST_ARCHIVE',
  FETCH_EMPLOYEE_POSITION_FAST_ARCHIVE_SUCCESS = 'FETCH_EMPLOYEE_POSITION_FAST_ARCHIVE_SUCCESS',
  GET_Draft_EMPLOYEE_POSITION_FOLDERS = 'GET_Draft_EMPLOYEE_POSITION_FOLDERS',
  GET_TRASH_EMPLOYEE_POSITION_FOLDERS = 'GET_TRASH_EMPLOYEE_POSITION_FOLDERS',

  //SEND BOX
  CLEAR_SENDBOX_EMPLOYEE_POSITION_FOLDERS = 'CLEAR_SENDBOX_EMPLOYEE_POSITION_FOLDERS',
  GET_SENDBOX_EMPLOYEE_POSITION_FOLDERS = 'GET_SENDBOX_EMPLOYEE_POSITION_FOLDERS',
  FETCH_SENDBOX_EMPLOYEE_POSITION_fOLDERS_SUCCESS = 'FETCH_SENDBOX_EMPLOYEE_POSITION_fOLDERS_SUCCESS',
  FETCH_Draft_EMPLOYEE_POSITION_fOLDERS_SUCCESS = 'FETCH_Draft_EMPLOYEE_POSITION_fOLDERS_SUCCESS',
  FETCH_TRASH_EMPLOYEE_POSITION_fOLDERS_SUCCESS = 'FETCH_TRASH_EMPLOYEE_POSITION_fOLDERS_SUCCESS',
  GET_LetterBodyImage = 'GET_LetterBodyImage',
  FETCH_LetterBodyImage_SUCCESS = 'FETCH_LetterBodyImage_SUCCESS',
  CHANGE_LetterBodyImage = 'CHANGE_LetterBodyImage',
  CHANGE_LetterBodyImage_SUCCESS = 'CHANGE_LetterBodyImage_SUCCESS',
  CLEAR_LetterBodyImage = 'CLEAR_LetterBodyImage',

  //SECRETARIAT_LIST
  GET_SECRETARIAT_LIST = 'GET_SECRETARIAT_LIST',
  FETCH_SECRETARIAT_LIST_SUCCESS = 'FETCH_SECRETARIAT_LIST_SUCCESS',
  // CHANGE_SECRETARIAT_ID = "CHANGE_SECRETARIAT_ID",
  //FOLDER
  GET_LETTERFOLDER_LIST = 'GET_LETTERFOLDER_LIST',
  FETCH_LETTERFOLDER_LIST_SUCCESS = 'FETCH_LETTERFOLDER_LIST_SUCCESS',

  CHANGE_STATE_ITEMS_VALUE = 'CHANGE_STATE_ITEMS_VALUE',
  CHANGE_STATE_ITEMS_VALUE_WITH_TYPE = 'CHANGE_STATE_ITEMS_VALUE_WITH_TYPE',
  //URGENT TYPE
  GET_URGENT_TYPE = 'GET_URGENT_TYPE',
  FETCH_URGENT_TYPE_SUCCESS = 'FETCH_URGENT_TYPE_SUCCESS',
  //URGENT TYPE
  GET_CLASSIFICATION_TYPE = 'GET_CLASSIFICATION_TYPE',
  FETCH_CLASSIFICATION_TYPE_SUCCESS = 'FETCH_CLASSIFICATION_TYPE_SUCCESS',

  //RECEIVERS_LIST
  GET_RECEIVERS_LIST = 'GET_RECEIVERS_LIST',
  FETCH_RECEIVERS_LIST_SUCCESS = 'FETCH_RECEIVERS_LIST_SUCCESS',

  //RECEIVERS_LIST
  GET_EMPLOYEEPOSITION_REFER_TEXT = 'GET_EMPLOYEEPOSITION_REFER_TEXT',
  FETCH_EMPLOYEEPOSITION_REFER_TEXT_SUCCESS = 'FETCH_EMPLOYEEPOSITION_REFER_TEXT_SUCCESS',

  //ASSIGN
  GET_REFER_DETAILS = 'GET_REFER_DETAILS',
  FETCH_REFER_DETAILS_SUCCESS = 'FETCH_REFER_DETAILS_SUCCESS',
  CHANGE_ASSIGN_STATE_ITEMS_VALUE_WITH_TYPE = 'CHANGE_ASSIGN_STATE_ITEMS_VALUE_WITH_TYPE',
  CHANGE_ASSIGN_STATE_ITEMS_VALUE = 'CHANGE_ASSIGN_STATE_ITEMS_VALUE',
  CHANGE_ASSIGN_STATE_FILEDS_ITEMS_VALUE = 'CHANGE_ASSIGN_STATE_FILEDS_ITEMS_VALUE',
  CHANGE_ASSIGN_STATE_LETTER_REFERS_ITEMS_VALUE = 'CHANGE_ASSIGN_STATE_LETTER_REFERS_ITEMS_VALUE',
  SEND_REFER = 'SEND_REFER',
  SEND_REFER_SUCCESS = 'SEND_REFER_SUCCESS',
  GET_RECEIVERS_FOR_REPLY = 'GET_RECEIVERS_FOR_REPLY',
  FETCH_RECEIVERS_FOR_REPLY_SUCCESS = 'FETCH_RECEIVERS_FOR_REPLY_SUCCESS',
  CLEAR_ASSIGN_DETAILS_STATE = 'CLEAR_ASSIGN_DETAILS_STATE',
  FAST_REFER = 'FAST_REFER',
  FAST_REFER_SUCCESS = 'FAST_REFER_SUCCESS',
  CHANGE_ASSIGN_STATE_LETTER_REFERS_ITEMS_VALUE_WITH_TYPE = 'CHANGE_ASSIGN_STATE_LETTER_REFERS_ITEMS_VALUE_WITH_TYPE',
  ON_ASSIGN_BODY_LETTER_REFER_ARRAY_ITEM = 'ON_ASSIGN_BODY_LETTER_REFER_ARRAY_ITEM',

  //ARCHIVE
  GET_PERSONAL_ARCHIVE_FOLDERS = 'GET_PERSONAL_ARCHIVE_FOLDERS',
  FETCH_PERSONAL_ARCHIVE_FOLDERS_SUCCESS = 'FETCH_PERSONAL_ARCHIVE_FOLDERS_SUCCESS',
  GET_ORGANIZATION_ARCHIVE_FOLDERS = 'GET_ORGANIZATION_ARCHIVE_FOLDERS',
  FETCH_ORGANIZATION_ARCHIVE_FOLDERS_SUCCESS = 'FETCH_ORGANIZATION_ARCHIVE_FOLDERS_SUCCESS',
  CHANGE_ARCHIVE_STATE_ITEMS_VALUE = 'CHANGE_ARCHIVE_STATE_ITEMS_VALUE',
  SET_PERSONAL_ARCHIVE = 'SET_PERSONAL_ARCHIVE',
  SET_PERSONAL_ARCHIVE_SUCCESS = 'SET_PERSONAL_ARCHIVE_SUCCESS',
  SET_ORGANIZATION_ARCHIVE = 'SET_ORGANIZATION_ARCHIVE',
  SET_ORGANIZATION_ARCHIVE_SUCCESS = 'SET_ORGANIZATION_ARCHIVE_SUCCESS',
  FAST_ARCHIVE = 'FAST_ARCHIVE',
  FAST_ARCHIVE_SUCCESS = 'FAST_ARCHIVE_SUCCESS',

  //CREATE LETTER
  CREATE_LETTER = 'CREATE_LETTER',
  CREATE_LETTER_SUCCESS = 'CREATE_LETTER_SUCCESS',

  //DRAFT EDITOR
  CHANGE_EDITOR_DRAFT = 'CHANGE_EDITOR_DRAFT',
  //GET GUID
  GET_GUID = 'GET_GUID',
  GET_GUID_Success = 'GET_GUID_Success',

  //UPLOAD  FILE
  CLEAR_UPLOAD_FILE = 'CLEAR_UPLOAD_FILE',
  UPLOAD_FILE = 'UPLOAD_FILE',
  UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS',
  DELETE_FILE = 'DELETE_FILE',
  DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS',

  //DELETE DELETER
  DELETE_DRAFT = 'DELETE_DRAFT',
  DELETE_DRAFT_SUCCESS = 'DELETE_DRAFT_SUCCESS',

  //Signature
  CHECK_CAN_SIGN_LETTER = 'CHECK_CAN_SIGN_LETTER',
  CHECK_CAN_CONFIRM_LETTER = 'CHECK_CAN_CONFIRM_LETTER',
  CHECK_CAN_SIGN_LETTER_SUCCESS = 'CHECK_CAN_SIGN_LETTER_SUCCESS',
  CHECK_CAN_CONFIRM_LETTER_SUCCESS = 'CHECK_CAN_CONFIRM_LETTER_SUCCESS',
  GET_SIGNATURE_LIST = 'GET_SIGNATURE_LIST',
  FETCH_SIGNATURE_LIST_SUCCESS = 'FETCH_SIGNATURE_LIST_SUCCESS',
  SIGN_LETTER = 'SIGN_LETTER',
  SIGN_LETTER_SUCCESS = 'SIGN_LETTER_SUCCESS',
  CONFIRM_LETTER = 'CONFIRM_LETTER',
  CONFIRM_LETTER_SUCCESS = 'CONFIRM_LETTER_SUCCESS',
  REMOVE_CONFIRM_LETTER = 'REMOVE_CONFIRM_LETTER',
  REMOVE_CONFIRM_LETTER_SUCCESS = 'REMOVE_CONFIRM_LETTER_SUCCESS',
  //SEND LETTER
  SEND_LETTER = 'SEND_LETTER',
  SEND_LETTER_SUCCESS = 'SEND_LETTER_SUCCESS',
  CHANGE_SEND_LETTER_STATUS = 'CHANGE_SEND_LETTER_STATUS',

  //RETRIVE LETTER
  RETRIVE_LETTER = 'RETRIVE_LETTER',
  RETRIVE_LETTER_SUCCESS = 'RETRIVE_LETTER_SUCCESS',
  ClearSignatureState = 'ClearSignatureState',

  //FastSign
  FAST_SIGN = 'FAST_SIGN',
  FAST_SIGN_SUCCESS = 'FAST_SIGN_SUCCESS',
  GET_FAST_SING = 'GET_FAST_SING',
  GET_FAST_SING_SUCCESS = 'GET_FAST_SING_SUCCESS',

  // for logOut or change EP code
  DESTROY_SESSION = 'DESTROY_SESSION',

  //LETTER RELATION
  GET_LETTER_RELATION = 'GET_LETTER_RELATION',
  FETCH_LETTER_RELATION_SUCCESS = 'FETCH_LETTER_RELATION_SUCCESS',

  // Chat
  GET_CHAT_CONTACTS = 'GET_CHAT_CONTACTS',
  FETCH_CHAT_CONTACTS_SUCCESS = 'FETCH_CHAT_CONTACTS_SUCCESS',
  GET_CONVERSATIONS = 'GET_CONVERSATIONS',
  FETCH_CONVERSATIONS_SUCCESS = 'FETCH_CONVERSATIONS_SUCCESS',
  GET_DISABLE_SEND_FILE_IN_CHAT = 'GET_DISABLE_SEND_FILE_IN_CHAT',
  FETCH_DISABLE_SEND_FILE_IN_CHAT_SUCCESS = 'FETCH_DISABLE_SEND_FILE_IN_CHAT_SUCCESS',
  CHAT_FILE_UPLOAD = 'CHAT_FILE_UPLOAD',
  CHAT_FILE_UPLOAD_SUCCESS = 'CHAT_FILE_UPLOAD_SUCCESS',
  ADD_CHAT_IMG_URL = 'ADD_CHAT_IMG_URL',
  CLEAR_CHAT_IMG_URL = 'CLEAR_CHAT_IMG_URL',
  // version 2 <--
  GET_USER_ROOMS = 'GET_USER_ROOMS',
  FETCH_USER_ROOMS_SUCCESS = 'FETCH_USER_ROOMS_SUCCESS',
  SELECT_ROOM = 'SELECT_ROOM',
  GET_NEW_ROOM_MESSAGES = 'GET_NEW_ROOM_MESSAGES',
  FETCH_NEW_ROOM_MESSAGES_SUCCESS = 'FETCH_NEW_ROOM_MESSAGES_SUCCESS',
  GET_OLD_ROOM_MESSAGES = 'GET_OLD_ROOM_MESSAGES',
  FETCH_OLD_ROOM_MESSAGES_SUCCESS = 'FETCH_OLD_ROOM_MESSAGES_SUCCESS',
  SEARCH_ROOMS = 'SEARCH_ROOMS',
  SEARCH_ROOMS_SUCCESS = 'SEARCH_ROOMS_SUCCESS',
  GET_ROOM_BY_CODE = 'GET_ROOM_BY_CODE',
  GET_USER_INFO = 'GET_USER_INFO',
  GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS',
  SEND_TEXT_MESSAGE = 'SEND_TEXT_MESSAGE',
  SEND_TEXT_MESSAGE_SUCCESS = 'SEND_TEXT_MESSAGE_SUCCESS',
  NOTIFY_NEW_MESSAGE = 'NOTIFY_NEW_MESSAGE',
  ADD_NEW_ROOM = 'ADD_NEW_ROOM',
  ADD_NEW_ROOM_SUCCESS = 'ADD_NEW_ROOM_SUCCESS',
  CLEAR_CONVERSATIONS_MESSAGES = 'CLEAR_CONVERSATIONS_MESSAGES',
  CLEAR_UNREAD_IDS = 'CLEAR_UNREAD_IDS',
  MARK_MESSAGE_AS_READ = 'MARK_MESSAGE_AS_READ',
  GET_USER_ROOMS_WITH_NEW_MESSAGE = 'GET_USER_ROOMS_WITH_NEW_MESSAGE',
  GET_USER_ROOMS_WITH_NEW_MESSAGE_SUCCESS = 'GET_USER_ROOMS_WITH_NEW_MESSAGE_SUCCESS',
  GET_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE = 'GET_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE',
  GET_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE_SUCCESS = 'GET_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE_SUCCESS',
  DELETE_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE = 'DELETE_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE',
  IS_DISCONNECTED = 'IS_DISCONNECTED',

  // APPOINTMENT
  GET_APPOINTMENTS = 'GET_APPOINTMENTS',
  FETCH_APPOINTMENTS_SUCCESS = 'FETCH_APPOINTMENTS_SUCCESS',
  GET_APPOINTMENTS_CALENDARS = 'GET_APPOINTMENTS_CALENDARS',
  FETCH_APPOINTMENTS_CALENDARS_SUCCESS = 'FETCH_APPOINTMENTS_CALENDARS_SUCCESS',

  //BPM
  SET_BPM_URL = 'SET_BPM_URL',
  GET_BPM_NEW_CASE_URL = 'GET_BPM_NEW_CASE_URL',
  FETCH_BPM_NEW_CASE_URL_SUCCESS = 'FETCH_BPM_NEW_CASE_URL_SUCCESS',

  //USER_CONFIG
  GET_PWA_USER_CONFIG = 'GET_PWA_USER_CONFIG',
  FETCH_PWA_USER_CONFIG_SUCCESS = 'FETCH_PWA_USER_CONFIG_SUCCESS',
  SET_USER_CONFIG = 'SET_USER_CONFIG',
  SET_USER_CONFIG_SUCCESS = 'SET_USER_CONFIG_SUCCESS',
  FETCH_TRASH_EMPLOYEE_POSITION_FOLDERS_SUCCESS = 'FETCH_TRASH_EMPLOYEE_POSITION_FOLDERS_SUCCESS',

  //REFER
  UPLOAD_REFER_FILE = 'UPLOAD_REFER_FILE',
  UPLOAD_REFER_FILE_SUCCESS = 'UPLOAD_REFER_FILE_SUCCESS',
  REMOVE_REFER_FILE = 'REMOVE_REFER_FILE',
  REMOVE_REFER_FILE_SUCCESS = 'REMOVE_REFER_FILE_SUCCESS',

  //ROUTEHISTORY
  ROUTE_HISTORY = 'ROUTE_HISTORY',
  //Dms
  GET_DMS_LIST = 'GET_DMS_LIST',
  GET_DMS_LIST_SUCCESS = 'GET_DMSLIST_SUCCESS',
  GET_DMS_FULL_LIST = 'GET_DMS_FULL_LIST',
  GET_DMS_LIST_FULL_SUCCESS = 'GET_DMS_LIST_FULL_SUCCESS',
}
